import { render, staticRenderFns } from "./BnRetrClients.vue?vue&type=template&id=1492071e&"
import script from "./BnRetrClients.vue?vue&type=script&lang=js&"
export * from "./BnRetrClients.vue?vue&type=script&lang=js&"
import style0 from "./BnRetrClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports